import { ihm_viewer__dictionary, locale } from 'Application/i18n/i18nViewer';
import { GlassSelect } from '../common/GlassSelect';

const VIEW_OPTIONS = [
    { label: ihm_viewer__dictionary.VIEW_MODE[locale()], value: '', disabled: true },
    { label: ihm_viewer__dictionary.SINGLE_MODE[locale()], value: 'single', disabled: false },
    { label: ihm_viewer__dictionary.DOUBLE_MODE[locale()], value: 'double', disabled: false },
    { label: ihm_viewer__dictionary.TRIPLE_MODE[locale()], value: 'triple', disabled: false },
    { label: ihm_viewer__dictionary.COMPARATIVE_VIEW[locale()], value: 'comparative', disabled: false }
];

export const ViewModeSelector = ({ passive, onEditMode, viewportMode, handleViewportChange }) => {
    const isNotPassive = !passive;
    const options = VIEW_OPTIONS.map(option => {
        const isComparativeDisabled = onEditMode && option.value === 'comparative';
        return { ...option, disabled: option.disabled || isComparativeDisabled };
    });

    return (
        <div id="viewModeSelector" className="vh-select-group hide-mobile">
            {isNotPassive && (
                <>
                    <label htmlFor='viewportSelector'>{ihm_viewer__dictionary.VIEW_MODE[locale()]}</label>
                    <GlassSelect
                        id="viewportSelector"
                        options={options}
                        value={viewportMode || 'single'}
                        onChange={handleViewportChange}
                    />
                </>
            )}
        </div>
    );
};
